/* eslint-disable import/extensions */
import React, { Component } from 'react';
import { IconButton } from 'veronica-ui-component/dist/component/core/IconButtons/IconButtons';
import { StyledMain, StyledNav } from '../styled/nbisNavigationMenu.styled';
import NbisMenuItems from './NbisNavigationMenuItems';

interface NbisNavigationSubMenu {
  title?: string,
  submenu?: NbisNavigationSubMenu[],
  command?: any
}

export interface NbisNavigationMenuItems extends NbisNavigationSubMenu {
  type?: string,
  separator?: boolean,
}

export interface NbisNavigationProps {
  menuItems?: NbisNavigationMenuItems[],
  id?: string | 'NavigationMenu',
  onSubMenuExpend?: boolean,
  onSubMenuLeave?: any,
  toggleMenu?: (isShow: boolean) => void;
}

class NbisNavigationMenu extends Component<NbisNavigationProps, {}, any> {
  state = {
    showNav: false,
    showSubMenu: false,
    menuPosition: 'top',
  };

  navRef: any = React.createRef();
  menuRef: any = React.createRef();

  /* istanbul ignore next */
  componentDidMount() {
    document.addEventListener('click', (e: any) => {
      const nav = this.navRef?.current?.contains(e.target);
      if (!nav) {
        this.setState({ showNav: false, showSubMenu: false });
        if (this.props.toggleMenu) this.props.toggleMenu(false);
      }
      return this.props.onSubMenuLeave && this.props.onSubMenuLeave(this.state.showSubMenu);
    });
  }

  handleToggleMenu = () => {
    const showNav = !this.state.showNav;
    this.setState({ showNav, showSubMenu: false }, () => {
      if (showNav) {
        this.calculateMenuPosition();
      }
    });
    if (this.props.toggleMenu) this.props.toggleMenu(showNav);
  };

  calculateMenuPosition = () => {
    const menuElement = this.menuRef.current;
    if (menuElement) {
      const rect = menuElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (rect.bottom > viewportHeight) {
        this.setState({ menuPosition: 'top' });
      } else {
        this.setState({ menuPosition: 'bottom' });
      }
    }
  };

  onMenuClick = (menu: any) => {
    menu.command(menu);
    this.setState({ showNav: false });
    return this.props.onSubMenuLeave && this.props.onSubMenuLeave(this.state.showSubMenu);
  };

  onSubMenuClick = (e: any) => {
    if (e !== 0) { this.setState({ showNav: false }); }
    return this.props.onSubMenuLeave && this.props.onSubMenuLeave(this.state.showSubMenu);
  };

  handleMouseOver = () => {
    this.setState({ showNav: true });
    if (this.props.toggleMenu) this.props.toggleMenu(true);
  };

  handleMouseLeave = () => {
    if (!this.state.showSubMenu) {
      this.setState({ showNav: false });
      if (this.props.toggleMenu) this.props.toggleMenu(false);
    }
  };

  render() {
    const { showNav } = this.state;
    let { menuItems, id = 'NavigationMenu', onSubMenuExpend = false } = this.props;

    /* istanbul ignore next */
    return (
      <StyledNav id={id} ref={this.navRef}>
        <IconButton iconClassName="icon" fileName="Icon-menu" tooltipDisable={true} onClick={this.handleToggleMenu} />
        {showNav && (
          <StyledMain
            className={`dropdown ${showNav ? 'show' : ''}`}
            onMouseOver={this.handleMouseOver}
            onMouseLeave={this.handleMouseLeave}
            ref={this.menuRef}
          >
            {menuItems?.map((menu, index) => {
              const depthLevel = 0;
              return (!menu.submenu && menu.command ? (
                <NbisMenuItems items={menu} key={index} id={`menuitems-${index}`} depthLevel={depthLevel} onClick={() => this.onMenuClick(menu)} />
              ) : (
                <NbisMenuItems
                  items={menu}
                  key={index}
                  id={`menuitems-${index}`}
                  depthLevel={depthLevel}
                  onClick={() => onSubMenuExpend && this.setState({ showSubMenu: true })}
                  onSubMenuClick={this.onSubMenuClick}
                />
              ));
            })}
          </StyledMain>
        )}
      </StyledNav>
    );
  }
}
export { NbisNavigationMenu };

